window.addEventListener('keyup', function (e) {
  const keyCode = (e.keyCode ? e.keyCode : e.which);
  
  if (keyCode == 9){
    const focusedElement = e.target.closest('.focus-el');
    const activeFocusedElement = document.querySelector('.focus-el.is-focusin');
    
    if (focusedElement) {
      if (!focusedElement.classList.contains('is-focusin')) {
        if (activeFocusedElement) activeFocusedElement.classList.remove('is-focusin');
        
        focusedElement.classList.add('is-focusin');
      }
    } else {
      if (activeFocusedElement) activeFocusedElement.classList.remove('is-focusin');
    }
  }
});

document.addEventListener('click', (e) => {
  if (e.target.closest('.focus-el') === null && document.querySelector('.focus-el.is-focusin')) {
    document.querySelector('.focus-el.is-focusin').classList.remove('is-focusin');
  }
});


window.addEventListener('keyup', function (e) {
  const keyCode = (e.keyCode ? e.keyCode : e.which);
  
  if (keyCode == 9){
    const focusedElement = e.target.closest('.child-focus-el');
    const activeFocusedElement = document.querySelector('.child-focus-el.child-is-focusin');
    
    if (focusedElement) {
      if (!focusedElement.classList.contains('child-is-focusin')) {
        if (activeFocusedElement) activeFocusedElement.classList.remove('child-is-focusin');
        
        focusedElement.classList.add('child-is-focusin');
      }
    } else {
      if (activeFocusedElement) activeFocusedElement.classList.remove('child-is-focusin');
    }
  }
});

document.addEventListener('click', (e) => {
  if (e.target.closest('.child-focus-el') === null && document.querySelector('.child-focus-el.is-focusin')) {
    document.querySelector('.child-focus-el.child-is-focusin').classList.remove('child-is-focusin');
  }
});

const bestSellerSection = document.getElementById('best__selller-products');

if (bestSellerSection) {
  fetch(`${window.location.pathname}?sort_by=best-selling&section_id=${bestSellerSection.dataset.section}`)
  .then(response => response.text())
  .then(html => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const products = [...doc.querySelectorAll('.product-grid .grid__item')];
    
    if (products.length) {
      bestSellerSection.querySelector('.featured__products-loader').remove();

      products.slice(0,7).forEach( product => {
        bestSellerSection
          .querySelector('.featured__products-slider')
          .insertAdjacentHTML('beforeend', `<div class="featured__products-item">${product.innerHTML}</div>`);
      });

      const bestSellerFlickity = new Flickity( '.featured__products-slider', {
        wrapAround: true,
        cellAlign: 'left',
        contain: true,
        percentPosition: false,
        prevNextButtons: false,
        pageDots: false
      });
    } else {
      bestSellerSection.remove();
    }
  });
}

const facetAccordions = document.querySelectorAll('.facet__cst-accordion .facet__cst-title');

facetAccordions.forEach( facetAccordion => {
  facetAccordion.addEventListener( 'click', () => {
    facetAccordion.classList.toggle('is-active');
    facetAccordion.closest('.facet__cst-accordion').querySelector('.facet__cst-list').classList.toggle('opened');
  });
});


// document.addEventListener('copy', function (e) {
//   e.preventDefault(); // Prevent the copy event
// });

// document.addEventListener('paste', function (e) {
//   e.preventDefault(); // Prevent the paste event
// });

// window.addEventListener('contextmenu', function (e) {
//   e.preventDefault();
// });

// window.addEventListener('keydown', function (e) {
//   if ((e.key == 'F12' || e.key == 'Control' || e.keyCode == 123) || (e.ctrlKey && e.shiftKey && e.keyCode == 73)) {
//     e.preventDefault(); // Prevent the developer tools from opening
//   }
// });

// window.addEventListener('keydown', function (e) {
//   if (e.ctrlKey && e.shiftKey && (e.key === 'C' || e.keyCode === 67)) {
//     e.preventDefault();
//   }
// });

const images = document.querySelectorAll('img');
images.forEach((image) => {
  image.draggable = false;
});


// scroll to top 

const button = document.querySelector('.scroll-button');
const displayButton = () => {
  window.addEventListener('scroll', () => {
    if (window.scrollY > 400) {
      button.classList.add("on");
    } else {
      button.classList.remove("on");
    }
  });
}; 
const scrollToTop = () => {
  button.addEventListener("click", () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    }); 
  });
};  
displayButton();
scrollToTop();
